import { Box, List, useTheme, InputBase } from "@mui/material"
import SHModal from "../../theme/Modal/SHModal"
import Shbutton from "../../theme/buttons/Shbutton"
import { tokens } from "../../../theme";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import NumberInput from "../../theme/inputs/NumberInput";
import SelectGroup from "../../theme/Select/SelectGroup";
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import ShSwitch from "../../theme/inputs/ShSwitch";
import { useSelector } from "react-redux";

// Asks the reason for pausing an order. The same modal asks the reason for finalizing an order
// without its label: `title` and `reasonLabel` replace the texts, `hideFollowUp` drops the
// customer follow-up switch and `reasonRequired` keeps confirm off until a reason is filled.
const MPauseOrder = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            confirm();
        }
    };

    const [pauseInfo, setPauseInfo] = useState({
        skipReason: "",
        followUpByCustomer: false
    });

    const handleChange = (key, value) => {
        setPauseInfo(prevInfo => ({
            ...prevInfo,
            [key]: value
        }));
    }

    const reasonMissing = props.reasonRequired && pauseInfo.skipReason.trim().length === 0;

    const confirm = () => {
        if (reasonMissing) {
            return;
        }
        const pauseCopy = pauseInfo;
        setPauseInfo({
            skipReason: "",
            followUpByCustomer: false
        });

        props.confirm(pauseCopy);
        props.handleClose();
    }

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
            onKeyDown={handleKeyDown}
        >
            <Box
                sx={{

                        maxWidth:500,
                }}
            >
                <Box 
                    sx={{
                        textAlign:"center",
                        paddingY:4,
                        paddingX:5,
                        display:"flex",
                        flexDirection:"column",
                        gap:1,
                        // maxWidth:420,
                    }}>
                    <Subheading>{props.title ?? <>{t("skip_order_title_1")}{props.orderNumber}{t("skip_order_title_2")}</>}</Subheading>
                </Box>
                <Box sx={{ 
                    pt:3,
                    paddingLeft: 3,
                    paddingRight: 3,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                }}>
                    <Box
                    >
                        <Text light>{props.reasonLabel ?? t("reason_to_skip")}</Text>
                    </Box>
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <InputBase 
                            sx={{
                                px:2,
                                flex:1, 
                                color:colors.txt["primary"],
                                lineHeight:"32px",
                            }}
                            value={pauseInfo.skipReason}
                            onChange={(e) => {handleChange("skipReason", e.target.value)}}
                        />
                    </Box>
                </Box>
                {isFulfilment && !props.hideFollowUp && (
                <Box sx={{ 
                    pt:3,
                    paddingLeft: 3,
                    paddingRight: 3,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                }}>
                    <Box
                    >
                        <Text light>{t("follow_up_customer")}</Text>
                    </Box>
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                            <ShSwitch
                                checked={pauseInfo.followUpByCustomer ?? false}
                                onChange={(e) => handleChange("followUpByCustomer", e.target.checked)}
                            />
                    </Box>
                </Box>
                )}
                <Box
                    component="footer"
                    sx={{
                        
                        display:"block",
                        width:1,
                        paddingBottom: isStandAlone ? "32px" : "16px",
                        display:"flex",
                        alignItems:"center",
                        paddingRight:3,
                        zIndex:1058,
                        position:"relative",
                        paddingTop:2,
                        background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderBottomLeftRadius:24,
                        borderBottomRightRadius:24,
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            paddingRight:0,
                        }
                    }}
                >
                    
                    <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                    <ButtonGroup version={2}>
                        <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} onClick={confirm} disabled={reasonMissing} variant="contained">{t("confirm")}</Shbutton>
                    </ButtonGroup>
                </Box>
            </Box>
        </SHModal>
    )
}

export default MPauseOrder;